<template>
  <v-container
    fluid
    class="pa-2"
  >
    <v-layout
      row
      wrap
    >
      <v-flex>
        <v-card class="max-shadow">
          <v-card-title>
            <div class="title-2">
              Invoices
            </div>
            <v-spacer />
          </v-card-title>
          <v-data-table
            id="invoicesTable"
            :headers="invoicesHeaders"
            :items="invoices"
            :loading="invoicesLoading"
            item-key="id"
            no-data-text="No invoices found"
            class="px-2 pb-2"
            disable-initial-sort
            hide-actions
          >
            <v-progress-linear
              slot="progress"
              color="primary"
              indeterminate
            />
            <template
              slot="items"
              slot-scope="props"
            >
              <tr
                class=" row-border"
                style="cursor: pointer;"
                @click="previewInvoice(props.item)"
              >
                <td style="width: 20px">
                  {{ props.index + 1 }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.invoiceNumber }}
                </td>
                <td class="text-xs-left">
                  {{ formatDate(props.item.invoiceDate.toDate()) }}
                </td>
                <td class="text-xs-left">
                  {{ getStatus(props.item) }}
                </td>
                <td class="text-xs-left">
                  {{ formatDate(props.item.dueDate.toDate()) }}
                </td>
                <td class="text-xs-left">
                  {{ formatCurrency(props.item.total) }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="invoicePreviewDialog"
        scrollable 
        persistent
        lazy
        max-width="750"
      >
        <invoice-preview 
          :invoice="selectedInvoice"
          type="invoice"
          @close="invoicePreviewDialog = false"
        />
      </v-dialog>
    </v-layout>
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.determinate ? 3000 : 0"
    >
      {{ snackbar.text }}
      <v-btn
        v-if="snackbar.determinate"
        flat
        color="accent"
        @click.native="snackbar.show = false"
      >
        Close
      </v-btn>
      <v-progress-circular
        v-else
        indeterminate
        color="white"
      />
    </v-snackbar>
  </v-container>
</template>

<script>
import { firestore } from '@/firebase';
import _get from 'lodash/get';
import moment from 'moment';
import InvoicePreview from '@/components/max-admin/tenants/InvoicePreview';

export default {
  name: 'Invoices',
  components: {
    'invoice-preview': InvoicePreview
  },
  data() {
    return {
      invoices: [],
      selectedInvoice: {},
      invoicesLoading: false,
      invoicesHeaders: [
        {
          text: '#',
          value: false,
          align: 'left',
          width: '10px'
        },
        {
          text: 'Invoice#',
          value: 'invoiceNumber',
          align: 'left'
        },
        {
          text: 'Date',
          value: 'invoiceDate',
          align: 'left'
        },
        {
          text: 'Status',
          value: 'status',
          align: 'left'
        },
        {
          text: 'Due Date',
          value: 'dueDate',
          align: 'left'
        },
        {
          text: 'Amount',
          value: 'total',
          align: 'left'
        }
        // {
        //   text: 'Actions',
        //   value: false,
        //   align: 'left'
        // }
      ],
      invoicePreviewDialog: false,
      snackbar: {
        show: false,
        text: '',
        determinate: true,
        color: 'primary'
      }
    };
  },
  computed: {
    cid() {
      return _get(this.$store.state.profile, 'cid');
    }
  },
  created() {
    //fetch invoices
    this.fetchInvoices();
    this.$store.commit('setToolbarTitle', { toolbarTitle: 'Invoices' });
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD MMM YYYY');
    },

    formatCurrency(val) {
      return val.toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        currency: 'INR'
      });
    },

    getStatus(invoice) {
      return moment(invoice.dueDate.toDate()).isBefore(moment(), 'date')
        ? 'OVERDUE'
        : invoice.status;
    },

    fetchInvoices() {
      firestore
        .collection('tenants')
        .doc(this.cid)
        .collection('invoices')
        .get()
        .then(invoicesSnapshot => {
          this.invoices = [];
          invoicesSnapshot.forEach(invoiceSnap => {
            this.invoices.push(
              Object.assign({ id: invoiceSnap.id }, invoiceSnap.data())
            );
          });
        })
        .catch(error => {
          //TODO: handle errors wherever there are not handled
          console.log(error);
        });
    },

    previewInvoice(invoice) {
      this.selectedInvoice = invoice;
      this.invoicePreviewDialog = true;
    }
  }
};
</script>
